import React from "react";
import "./SpaceScene.scss";

export default function SpaceScene() {
  return (
    <div className="space-scene" aria-hidden="true">
      <span className="scene-star star-one" />
      <span className="scene-star star-two" />
      <span className="scene-star star-three" />
      <span className="scene-star star-four" />
      <span className="scene-star star-five" />
      <span className="orbit orbit-one" />
      <span className="orbit orbit-two" />
      <div className="planet">
        <span className="planet-glow" />
        <span className="planet-land land-one" />
        <span className="planet-land land-two" />
      </div>
      <div className="satellite">
        <span className="solar-panel panel-left" />
        <span className="solar-panel panel-right" />
        <span className="satellite-body">
          <span className="satellite-window" />
        </span>
        <span className="satellite-antenna" />
      </div>
      <div className="rocket">
        <span className="rocket-window" />
        <span className="rocket-fin fin-left" />
        <span className="rocket-fin fin-right" />
        <span className="rocket-flame" />
      </div>
    </div>
  );
}
